import { createVuetify } from "vuetify";

const vuetifyOptions = {
    theme: {
        defaultTheme: 'appTheme',

        themes: {
            appTheme: {
                dark: false,
                colors: {
                    warning: '#fbc000',
                },
            },
        },
    },

    display: {
        thresholds: {
            md: 960,
            lg: 1280,
            xl: 1920,
            xxl: 2560,
        },
    },
};

export const createConfiguredVuetify = () =>
    createVuetify(vuetifyOptions);

export default createConfiguredVuetify();